import { logger } from "shared-ts/logger"

interface PrintPDFOptions {
  // TODO (Umer): update optional typing once implemented filenames for all PDFs
  fileName?: string
}

// printPDF takes in pdf bytes and opens the browser-native
// print modal without leaving the focused tab.
export function printPDF(bytes: Uint8Array, options?: PrintPDFOptions) {
  const ab = new ArrayBuffer(bytes.length)
  new Uint8Array(ab).set(bytes)
  const blob = new Blob([ab], {
    type: "application/pdf",
  })
  const url = URL.createObjectURL(blob)

  const iframe = document.createElement("iframe")
  document.body.appendChild(iframe)

  iframe.src = url
  iframe.style.display = "none"
  iframe.onload = () => {
    iframe.focus()
    // Browsers name a saved print after the page title.
    if (options?.fileName) {
      const title = document.title
      document.title = options.fileName
      window.addEventListener(
        "focus",
        () => {
          document.title = title
        },
        { once: true }
      )
    }
    try {
      iframe.contentWindow?.print()
    } catch (error) {
      logger.warn("print pdf error; printing in new tab", { error })
      window.open(url, "_blank")?.print()
    }
  }
}

// printPDFAsync sets up event listeners to wait for focus
// to be restored to an underlying component before returning
// from pdf printing
export const printPDFAsync = (bytes: Uint8Array, options?: PrintPDFOptions) =>
  new Promise((resolve) => {
    // Resolve immediately if the browser is in
    // headless mode (Playwright).
    if (navigator.webdriver) {
      resolve(true)
      return
    }
    let isPrinting = false

    const onRegainFocus = () => {
      if (!isPrinting) {
        return
      }
      resolve(true)
      window.removeEventListener("focus", onRegainFocus)
    }
    window.addEventListener("focus", onRegainFocus)

    isPrinting = true
    printPDF(bytes, options)
  })
